import Vue from 'vue';

Vue.component('instagram-reel-embed-component', {
    props: {
        id: {
            type: String,
            required: true,
        },
        width: {
            type: [String, Number],
            default: 540,
        },
        height: {
            type: [String, Number],
            default: 675,
        },
    },
    data() {
        return {
            embedHtml: null,
            isLoaded: false,
        };
    },
    mounted() {
        console.log('instagramID: ', this.id);

        this.loadInstagramEmbed();
    },
    methods: {
        loadInstagramEmbed() {
            if (!this.id) {
                this.embedHtml = '<div style="text-align:center;color:#c00;padding:2em;">Instagram Reel ID niet gevonden.</div>';
                return;
            }

            // Extract Instagram post ID from URL or use direct ID
            let postId = this.id;
            if (this.id.includes('instagram.com')) {
                const match = this.id.match(/\/p\/([A-Za-z0-9_-]+)/);
                if (match) {
                    [, postId] = match;
                } else {
                    this.embedHtml = '<div style="text-align:center;color:#c00;padding:2em;">Ongeldig Instagram Reel formaat.</div>';
                    return;
                }
            }

            // Create Instagram embed with TikTok-like styling
            const embedUrl = `https://www.instagram.com/p/${postId}/embed/`;
            const { width, height } = this;

            this.embedHtml = `<div class="instagram-reel-wrapper" style="max-width: ${width}px; margin: 0 auto;">
                    <div class="instagram-reel-container" style="
                        position: relative;
                        border-radius: 16px;
                        box-shadow: 0 2px 16px rgba(0,0,0,0.12);
                        overflow: hidden;
                        background: #fff;
                        border: none;
                    ">
                        <iframe
                            id="instagram-reel-iframe-${postId}"
                            src="${embedUrl}"
                            width="${width}"
                            height="${height}"
                            frameborder="0"
                            scrolling="no"
                            allowtransparency="true"
                            allow="encrypted-media"
                            title="Instagram Reel"
                            style="
                                border: none;
                                overflow: hidden;
                                max-width: 100%;
                                background: #fff;
                                border-radius: 16px;
                                display: block;
                            "
                        ></iframe>
                    </div>
                </div>`;

            // Load Instagram embed script and add custom styling
            this.$nextTick(() => {
                // Add custom CSS for Instagram embeds
                if (!document.getElementById('instagram-reel-styles')) {
                    const style = document.createElement('style');
                    style.id = 'instagram-reel-styles';
                    style.textContent = `
                        .instagram-reel-embed-component {
                            display: flex;
                            justify-content: center;
                        }
                        .instagram-reel-wrapper {
                            position: relative;
                        }
                        .instagram-reel-container {
                            transition: transform 0.2s ease;
                        }
                        .instagram-reel-container:hover {
                            transform: translateY(-2px);
                        }
                        .instagram-reel-wrapper iframe {
                            border-radius: 16px !important;
                        }
                        /* Hide Instagram branding elements for cleaner look */
                        .instagram-reel-wrapper iframe[src*="instagram.com"] {
                            filter: brightness(1.05) contrast(1.02);
                        }
                    `;
                    document.head.appendChild(style);
                }

                if (!window.instgrm && !this.isLoaded) {
                    const script = document.createElement('script');
                    script.src = 'https://www.instagram.com/embed.js';
                    script.async = true;
                    script.onload = () => {
                        if (window.instgrm) {
                            window.instgrm.Embeds.process();
                        }
                    };
                    document.head.appendChild(script);
                    this.isLoaded = true;
                } else if (window.instgrm) {
                    window.instgrm.Embeds.process();
                }
            });
        },
    },
    template: `
        <div class="instagram-reel-embed-component" v-if="embedHtml" v-html="embedHtml"></div>
        <div v-else style="text-align:center;padding:2em;">Instagram Reel laden...</div>
    `,
});
